// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3cI9P","questions":"styles_questions__1jFua","footer":"styles_footer__2KycY"};